import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './App';
import './index.css';

/**
 * Entry point — driven by vite-react-ssg's data router.
 *
 * In dev / the browser this hydrates the SPA exactly like the old
 * ReactDOM.createRoot did. At build time `vite-react-ssg build` walks the
 * `routes` array and pre-renders the public marketing pages to static HTML
 * (see ssgOptions.includedRoutes in vite.config.ts), so non-JS AI crawlers
 * see real content instead of an empty <div id="root">.
 *
 * App-wide providers (Helmet, ErrorBoundary, Auth) live in RootLayout inside
 * App.tsx so they wrap every route under the data router.
 */
export const createRoot = ViteReactSSG({ routes });
